import React from "react";
const InsightsContext = React.createContext({});
export default InsightsContext;
